import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "deepco-theme"

export default class extends Controller {
  static identifier = "theme"
  static targets = ["select"]

  connect() {
    const storedTheme = this.readStoredTheme()
    const initialTheme = storedTheme || this.currentDocumentTheme || this.defaultTheme || this.currentSelectTheme

    if (initialTheme) {
      this.applyTheme(initialTheme, { store: storedTheme == null })
      if (this.hasSelectTarget) {
        this.selectTarget.value = initialTheme
      }
    }
  }

  change(event) {
    const { value } = event.target
    this.applyTheme(value)
  }

  applyTheme(theme, { store = true } = {}) {
    if (!theme) return
    document.documentElement.setAttribute("data-theme", theme)

    if (store) {
      this.persistTheme(theme)
    }
  }

  readStoredTheme() {
    try {
      return window.localStorage.getItem(STORAGE_KEY)
    } catch (_error) {
      return null
    }
  }

  persistTheme(theme) {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme)
    } catch (_error) {
      // Ignore storage errors (e.g., private browsing)
    }
  }

  get currentDocumentTheme() {
    return document.documentElement.getAttribute("data-theme")
  }

  get defaultTheme() {
    return this.element.dataset.defaultTheme || null
  }

  get currentSelectTheme() {
    if (!this.hasSelectTarget) return null
    return this.selectTarget.value
  }
}
